import React, { useEffect, useState, useRef } from 'react';
import Pagination from '../Reusables/Pagination';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import getResponse from '../actions/Project';
import SearchSection from '../Reusables/SearchSection';
import { useNavigate, useLocation, useParams} from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Dropdown from '../Reusables/Dropdown'
import { parseBreadcrumbsList } from '../../store/Actions';
import '../../scss/projectreport.scss';
import Calender from '../Reusables/Calender';
import Spinner from '../Reusables/Spinner';
import RefreshToken from '../actions/RefreshToken';
import Cookies from 'js-cookie'
import Entries from '../Reusables/Entries';
import { convertToDateString, convertUTCToPST } from '../Reusables/Function';


function ClickOutside(ref, setFilter) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setFilter(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function ProjectReports(props) {
    const {project_type} = useParams();
    const accesstoken =  Cookies.get('access_token');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const filterwrapperRef = useRef(null);
    const [filterdetails, setFilter] = useState(false);
    ClickOutside(filterwrapperRef, setFilter);

    const [isLoading, setLoading] = useState(true);
    const [page, setPage] = useState('1');
    const [mindate, setminDate] = useState(false);
    const [totalpage, setTotalpage] = useState(10);
    const [searchstate, setSearch] = useState(false);
    const [sortstate, setSortstate] = useState(false);
    const [fromlabel, setFromLabel] = useState('Select Date');
    const [tolabel, setToLabel] = useState('Select Date');
    const [startfromdate, setFromStartDate] = useState(false);
    const [starttodate, setToStartDate] = useState(false);
    const [projectstate, setProjectState] = useState(false);
    const [entitystate, setEntityState] = useState(false);
    const [statustate, setStatusState] = useState(false);
    const [assignstate, setAssignState] = useState(false);
    const [datetypestate, setDatetypestate] = useState(false);
    const [fromstate, setFromstate] = useState(false);
    const [tostate, setTostate] = useState(false);
    const [disablefromto, setDisablefromto] = useState(true);
    const [disableto, setDisableto] = useState(true);
    const [entityList, setEntityList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [datetypelist, setDateTypeList] = useState([]);
    const [entityLabel, setEntityLabel] = useState('All');
    const [userLabel, setUserLabel] = useState('All');
    const [statusLabel, setStatusLabel] = useState('All');
    const [datetypelabel, setDateTypelabel] = useState('All');
    const [projectname, setProject] = useState('');
    const [projectReportlists, setProjectReportlists] = useState([]);
    const [projectReportdownload, setProjectReportdownload] = useState([]);
    const userRole = useSelector((state) => state.role);
    const userId = useSelector((state) => state.userId);
    const [limit, setLimit] = useState(30);

    const params = new URLSearchParams(location.search);
    const sort = params.has('sort') ? params.get('sort') : ''
    const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
   
    const headers = [
        { label: "Project Name", key: "name" },
        { label: "Status", key: "status" },
        { label: "Last Updated", key: "lastUpdated" },
        { label: "Billable Hours", key: "billableHrs" },
        { label: "Actual Hours", key: "actualHrs" },
        { label: "Project Due", key: "dueDate" },
        { label: "Property", key: "entity" }
    ]; 
     
    const filename = 'Projects Reports';

    function HandleChange(page) {
        console.log("PAGE", page);
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const search = params.has('search') ? params.get('search') : ''
        
        setPage(page);
        navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=${page}${sort ? `&sort=${sort}`: ''}${sort_order ? `&sort_order=${sort_order}`: ''}${search ? `&search=${search}`: ''}`);

        window.scroll(0, 0);
    }
   
    function FromDate(date) {
        setFromLabel(convertToDateString(date, "picker"));
        FromNavigate(date);
        setminDate(date);
        setFromStartDate(date);
        setDisableto(false);
    }
    function ToDate(date) {
        setToLabel(convertToDateString(date, "picker"));
        ToNavigate(date);
        setToStartDate(date);
    }
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Projects", "url": "projects/list" },
        { "name": "Projects Reports", "url": "projects/reports/list" }
    ];
    const searchValues = {
        isFilter: true,
        isCreate: false,
        placeholder: "Search Project",
    }

    function ToProjectDetails(id) {
        navigate(`/projects/${id}/view`);
    }

    const callSearchApi = (query) => {
        const params = new URLSearchParams(location.search);
        console.log("Searching URL", params);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        setSearch(!searchstate);
        navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${sort ? `&sort=${sort}`: ''}${sort_order ? `&sort_order=${sort_order}`: ''}&search=${query}`);
    }

    function SortProject(dataset) {
        setSortstate(!sortstate);
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        console.log("pageSORT1", page)
        let sortBy = dataset.sortBy;
        let sortType = dataset.sortType;
        navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${search ? `&search=${search}`: ''}&sort=${sortBy}&sort_order=${sortType}`);
    }

    function Filter() {
        setFilter(!filterdetails)
    } 

    function ProjectName(e) {
        setProjectState(!projectstate);
        var projectname = encodeURIComponent(e.target.value);
        setProject(projectname);
        const params = new URLSearchParams(location.search);
        const status = params.has('statuscode') ? params.get('statuscode') : '';
        const entity = params.has('property') ? params.get('property') : '';
        const assigned = params.has('assigned') ? params.get('assigned') : '';
        const datetype = params.has('datetype') ? params.get('datetype') : '';
        const from = params.has('from') ? params.get('from') : '';
        const to = params.has('to') ? params.get('to') : '';
        navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1&name=${projectname}${entity ? `&property=${entity}`: '' }${status ? `&statuscode=${status}` : ''}${assigned ? `&assigned=${assigned}`: '' }${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/');
            }
            else {
                const entityendpoint = `/api/entity/dropdown?projectName=${projectname}${assigned ? `&assignedTo=${assigned}` : ''}`;
                console.log('[Refresh][In]entityendpoint', entityendpoint)
                getResponse.GetEntityDropdown(accesstoken, entityendpoint, (response) => {  
                    if(response.status == 200) {
                        console.log('[Refresh1] response', response);        
                        const entityArray = [];
                        const entityObject = {id: 0, name: ''}
                        entityObject.id = null;
                        entityObject.name = 'All';
                        entityArray.push(entityObject);
                        response.data.data.map((task) => {
                            const entityObject = {id: 0, name: ''}
                            entityObject.id = task["idEntities"];
                            entityObject.name = task["entityName"];
                            entityArray.push(entityObject);
                        })
                        setEntityList(entityArray);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
        
                const assignendpoint = `/api/users/list?isProjectReport=true&projectName=${projectname}${entity ? `&entityId=${entity}` : ''}`;
                console.log('[Refresh][In]assignendpoint', assignendpoint);
                getResponse.GetAssignDropdown(accesstoken, assignendpoint, (response) => {   
                    if(response.status == 200) {
                        console.log('[Refresh2] response', response);    
                        const usersArray = [];
                        response.data.data.map((user) => {
                            const userObject = {id: 0, name: ''}
                            userObject.id = user["idUsers"];
                            userObject.name = ((user["firstName"] != null && user["lastName"] != null) ? 
                                (user["firstName"]+" "+user["lastName"]) : (user["firstName"]));
                            usersArray.push(userObject);
                        })
                        setUserList(sortUserList(usersArray));
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const sortUserList = (users) => {
        users.sort((a, b) => a.name.localeCompare(b.name))
        const userObject = {id: 0, name: ''}
        userObject.id = null;
        userObject.name = 'All';
        users.splice(0, 0, userObject); // adding at the first
        return users;
    }

    function EntitySelect(name, id) {
        setEntityState(!entitystate);
        const params = new URLSearchParams(location.search);
        const assigned = params.has('assigned') ? params.get('assigned') : ''
        const status = params.has('statuscode') ? params.get('statuscode') : ''
        const projectname = params.has('name') ? params.get('name') : '';
        const datetype = params.has('datetype') ? params.get('datetype') : '';
        const from = params.has('from') ? params.get('from') : '';
        const to = params.has('to') ? params.get('to') : '';

        if(name === 'All') {
            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${status ? `&statuscode=${status}` : ''}${assigned ? `&assigned=${assigned}`: '' }${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        }
        else {
            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}&property=${id}${status ? `&statuscode=${status}` : ''}${assigned ? `&assigned=${assigned}`: '' }${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/');
            }
            else {
                const assignendpoint = `/api/users/list?isProjectReport=true${projectname || id ? '&' : ''}${projectname ? `projectName=${projectname}` : ''}${projectname && id ? '&' : ''}${id ? `entityId=${id}` : ''}`;
                console.log('[Refresh][In]assignendpoint', assignendpoint)
                getResponse.GetAssignDropdown(accesstoken, assignendpoint, (response) => { 
                    if(response.status == 200) {
                        console.log('[Refresh3] response', response);          
                        const usersArray = [];
                        response.data.data.map((user) => {
                            const userObject = {id: 0, name: ''}
                            userObject.id = user["idUsers"];
                            userObject.name = ((user["firstName"] != null && user["lastName"] != null) ? 
                                (user["firstName"]+" "+user["lastName"]) : (user["firstName"]));
                            usersArray.push(userObject);
                        })
                        setUserList(sortUserList(usersArray));
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function StatusSelect(name, id) {
        setStatusState(!statustate);
        const params = new URLSearchParams(location.search);
        const entity = params.has('property') ? params.get('property') : ''
        const assigned = params.has('assigned') ? params.get('assigned') : ''
        const projectname = params.has('name') ? params.get('name') : '';
        const datetype = params.has('datetype') ? params.get('datetype') : '';
        const from = params.has('from') ? params.get('from') : '';
        const to = params.has('to') ? params.get('to') : '';

        if(name === 'All') {
            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}` : ''}${assigned ? `&assigned=${assigned}`: '' }${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        }
        else {
            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}` : ''}&statuscode=${id}${assigned ? `&assigned=${assigned}`: '' }${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        }
    }

    function AssignSeclect(name, id) {
        setAssignState(!assignstate);
        const params = new URLSearchParams(location.search);
        const entity = params.has('property') ? params.get('property') : ''
        const status = params.has('statuscode') ? params.get('statuscode') : ''
        const projectname = params.has('name') ? params.get('name') : '';
        const datetype = params.has('datetype') ? params.get('datetype') : '';
        const from = params.has('from') ? params.get('from') : '';
        const to = params.has('to') ? params.get('to') : '';

        if(name === 'All') {
            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}` : ''}${status ? `&statuscode=${status}` : ''}${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        }
        else {
            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}` : ''}${status ? `&statuscode=${status}` : ''}&assigned=${id}${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }${to ? `&to=${to}`: '' }`);
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/');
            }
            else {
                const entityendpoint = `/api/entity/dropdown${projectname || id ? '?' : ''}${projectname ? `projectName=${projectname}` : ''}${projectname && id ? '&' : ''}${id ? `assignedTo=${id}` : ''}`;
                console.log('[Refresh][In]entityendpoint', entityendpoint)
                getResponse.GetEntityDropdown(accesstoken, entityendpoint, (response) => { 
                    if(response.status == 200) {
                        console.log('[Refresh4] response', response);        
                        const entityArray = [];
                        const entityObject = {id: 0, name: ''}
                        entityObject.id = null;
                        entityObject.name = 'All';
                        entityArray.push(entityObject);
                        response.data.data.map((task) => {
                            const entityObject = {id: 0, name: ''}
                            entityObject.id = task["idEntities"];
                            entityObject.name = task["entityName"];
                            entityArray.push(entityObject);
                        })
                        setEntityList(entityArray);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function DateTypeSelect(name, id) {
        setDatetypestate(!datetypestate);
        setFromLabel('Select Date');
        setToLabel('Select Date');
        setminDate(false);
        setDisablefromto(false);
        const params = new URLSearchParams(location.search);
        const entity = params.has('property') ? params.get('property') : ''
        const assigned = params.has('assigned') ? params.get('assigned') : ''
        const projectname = params.has('name') ? params.get('name') : '';
        const status = params.has('statuscode') ? params.get('statuscode') : '';
        const fromvalue = params.has('from') ? params.get('from') : '';
        const tovalue = params.has('to') ? params.get('to') : '';
        if(name === 'All') {
            setDisablefromto(true);
            setDisableto(true);
            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}` : ''}${status ? `&statuscode=${status}` : ''}${assigned ? `&assigned=${assigned}`: '' }`);
        }
        else {
            console.log("namebefore", name);
            var datetype = name.replace(/\s/g, '').toLowerCase();
            console.log("nameafter", datetype);

            navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}` : ''}${status ? `&statuscode=${status}` : ''}${assigned ? `&assigned=${assigned}`: '' }&datetype=${datetype}${fromvalue ? `&from=${fromvalue}`: '' }${tovalue ? `&to=${tovalue}`: '' }`);
        }
    }

    function FromNavigate(date) {
        setFromstate(!fromstate);
        const params = new URLSearchParams(location.search);
        const projectname = params.has('name') ? params.get('name') : '';
        const status = params.has('statuscode') ? params.get('statuscode') : '';
        const entity = params.has('property') ? params.get('property') : '';
        const assigned = params.has('assigned') ? params.get('assigned') : '';
        const datetype = params.has('datetype') ? params.get('datetype') : '';
        const to = params.has('to') ? params.get('to') : '';
        var fromdate = convertToDateString(date, "");
        navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}`: '' }${status ? `&statuscode=${status}` : ''}${assigned ? `&assigned=${assigned}`: '' }${datetype ? `&datetype=${datetype}`: '' }&from=${fromdate}${to ? `&to=${to}`: '' }`);
    }

    function ToNavigate(date) {
        setTostate(!tostate);
        const params = new URLSearchParams(location.search);
        const projectname = params.has('name') ? params.get('name') : '';
        const status = params.has('statuscode') ? params.get('statuscode') : '';
        const entity = params.has('property') ? params.get('property') : '';
        const assigned = params.has('assigned') ? params.get('assigned') : '';
        const datetype = params.has('datetype') ? params.get('datetype') : '';
        const from = params.has('from') ? params.get('from') : '';
        var todate = convertToDateString(date, "");
        navigate(`/projects${project_type ? `/${project_type}` : ''}/reports/list?page=1${projectname ? `&name=${projectname}` : ''}${entity ? `&property=${entity}`: '' }${status ? `&statuscode=${status}` : ''}${assigned ? `&assigned=${assigned}`: '' }${datetype ? `&datetype=${datetype}`: '' }${from ? `&from=${from}`: '' }&to=${todate}`);
    }

    function GetEntityDropdown() {
        const projectname = params.has('name') ? params.get('name') : '';
        const assigned = params.has('assigned') ? params.get('assigned') : '';

        const endpoint = `/api/entity/dropdown${(projectname || assigned) ? '?' : ''}${projectname ? `projectName=${projectname}` : ''}${projectname && assigned ? '&' : ''}${assigned ? `assignedTo=${assigned}` : ''}`;
        getResponse.GetEntityDropdown(accesstoken, endpoint, (response) => {  
            if(response.status == 200) {
                const entityArray = [];
                const entityObject = {id: 0, name: ''}
                entityObject.id = null;
                entityObject.name = 'All';
                entityArray.push(entityObject);
                response.data.data.map((task) => {
                    const entityObject = {id: 0, name: ''}
                    entityObject.id = task["idEntities"];
                    entityObject.name = task["entityName"];
                    entityArray.push(entityObject);
                })
                setEntityList(entityArray);
            } else if(response.status == 401) {
                navigate("/login")
            }    
        });
    }

    function GetStatusDropdown() {
        setStatusList([
            {id: null, name: "All"},
            {id: 1, name: "Completed"}, 
            {id: 0, name: "Incomplete"}
        ])
    }

    function GetAssignDropdown() {
        const projectname = params.has('name') ? params.get('name') : '';
        const entity = params.has('property') ? params.get('property') : '';

        const endpoint = `/api/users/list?isProjectReport=true${(projectname || entity) ? '&' : ''}${projectname ? `projectName=${projectname}` : ''}${projectname && entity ? '&' : ''}${entity ? `entityId=${entity}` : ''}`;
        getResponse.GetAssignDropdown(accesstoken, endpoint, (response) => {   
            if(response.status == 200) {
                const usersArray = [];
                response.data.data.map((user) => {
                    const userObject = {id: 0, name: ''}
                    userObject.id = user["idUsers"];
                    userObject.name = ((user["firstName"] != null && user["lastName"] != null) ? 
                        (user["firstName"]+" "+user["lastName"]) : (user["firstName"]));
                    usersArray.push(userObject);
                })
                setUserList(sortUserList(usersArray));
            } else if(response.status == 401) {
                navigate("/login")
            }  
        });
    }

    function GetDateTypeDropdown() {
        setDateTypeList([
            {id: 1, name: "All"},
            {id: 2, name: "Task Completed"}, 
            {id: 3, name: "Task Last Updated"},
            {id: 4, name: "Task Due"},
            {id: 5, name: "Project Completed"}, 
            {id: 6, name: "Project Last Updated"},
            {id: 7, name: "Project Due"}
        ])
    }

    useEffect(() => {
        dispatch(parseBreadcrumbsList(breadcrumbsList));
    }, [])

    useEffect(() => {
        // Getting the dropdown list
        GetEntityDropdown();
        GetStatusDropdown();
        GetAssignDropdown();
        GetDateTypeDropdown();

        const params = new URLSearchParams(location.search);
        const pagenum = params.has('page') ? params.get('page') : 1
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const search = params.has('search') ? params.get('search') : ''

        const name = params.has('name') ? params.get('name') : '';
        const entityparam = params.has('property') ? params.get('property') : '';
        const statusparam = params.has('statuscode') ? params.get('statuscode') : '';
        const datetypeparam = params.has('datetype') ? params.get('datetype') : '';
        const assignedparam = userRole == 1 ? (params.has('assigned') ? params.get('assigned') : '') : userId;
        const fromparam = params.has('from') ? params.get('from') : '';
        const toparam = params.has('to') ? params.get('to') : '';
        
        setProject(name);

        const entityendpoint = "/api/entity/dropdown";
        getResponse.GetEntityDropdown(accesstoken, entityendpoint, (response) => { 
            if(response.status == 200) {
                console.log("responseentity", response);     
                response.data.data.map((item) => {
                    if(item.idEntities === Number(entityparam)) {
                        console.log("Entity", item.entityName)
                        setEntityLabel(item.entityName);
                    }
                })
            } else if(response.status == 401) {
                navigate("/login")
            }
        });

        if(statusparam === '0') {
            setStatusLabel('Incomplete');
        }
        else if(statusparam === '1') {
            setStatusLabel('Completed');
        }

        const assignedendpoint = "/api/users/list?isProjectReport=true";
        getResponse.GetAssignDropdown(accesstoken, assignedendpoint, (response) => {  
            if(response.status == 200) {
                response.data.data.map((item) => {
                    if(item.idUsers === Number(assignedparam)) {
                        setUserLabel(
                            ((item["firstName"] != null && item["lastName"] != null) ? 
                        (item["firstName"]+" "+item["lastName"]) : (item["firstName"]))
                        )
                    }
                })
            } else if(response.status == 401) {
                navigate("/login")
            }    
        });

        if(datetypeparam === 'tasklastupdated') {
            setDateTypelabel('Task Completed');
        }
        else if(datetypeparam === 'taskcompleted') {
            setDateTypelabel('Task Last Updated');
        }
        else if(datetypeparam === 'taskdue') {
            setDateTypelabel('Task Due');
        }
        else if(datetypeparam === 'projectcompleted') {
            setDateTypelabel('Project Completed');
        }
        else if(datetypeparam === 'projectlastupdated') {
            setDateTypelabel('Project Last Updated');
        }
        else if(datetypeparam === 'projectdue') {
            setDateTypelabel('Project Due');
        }

        if(datetypeparam) {
            setDisablefromto(false);
        }

        if(fromparam) {
            setminDate(new Date(fromparam));
            setDisableto(false);
            setFromLabel(convertToDateString(new Date(fromparam), "picker"));
            setFromStartDate(new Date(fromparam));
        }

        if(toparam) {
            setToLabel(convertToDateString(new Date(toparam), "picker"));
            setToStartDate(new Date(toparam));
        }
        function CallAPI(accesstoken) {
            const URL = `/api/project/report/list?page=${pagenum}&limit=${limit}${project_type ? `&project_type=${project_type}` : ''}${sort ? `&sort_by=${sort}` : ''}${sort_order ?
                 `&sort_type=${sort_order}` : ''}${search ? `&search=${search}` : ''}${name ? `&name=${name}` : ''}${entityparam ? 
                    `&entity=${entityparam}` : ''}${statusparam ? `&status=${statusparam}` : ''}${assignedparam ? `&assigned_to=${assignedparam}` : ''}
                    ${datetypeparam && fromparam && toparam? `&dateType=${datetypeparam}` : ''}${datetypeparam && fromparam && toparam ? `&startDate=${fromparam}` : ''}
                    ${datetypeparam && fromparam && toparam ? `&endDate=${toparam}` : ''}`;
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponse.GetProjectReportList(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        console.log("reportresponse", response)
                        setTotalpage(response.data.totalPages);
                        setProjectReportlists(response.data.data);
                        setLoading(false);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [page, searchstate, sortstate, projectstate, entitystate, statustate, 
        assignstate, datetypestate, fromstate, tostate, limit, project_type]);

    //Download
    useEffect(() => {

        const params = new URLSearchParams(location.search);
        const pagenum = params.has('page') ? params.get('page') : 1
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const search = params.has('search') ? params.get('search') : ''

        const name = params.has('name') ? params.get('name') : '';
        const entityparam = params.has('property') ? params.get('property') : '';
        const statusparam = params.has('statuscode') ? params.get('statuscode') : '';
        const datetypeparam = params.has('datetype') ? params.get('datetype') : '';
        const assignedparam = userRole == 1 ? (params.has('assigned') ? params.get('assigned') : '') : userId;

        const fromparam = params.has('from') ? params.get('from') : '';
        const toparam = params.has('to') ? params.get('to') : '';
             
        const URL = `/api/project/report/list?page=${pagenum}&limit=${limit}${project_type ? `&project_type=${project_type}` : ''}${sort ? `&sort_by=${sort}` : ''}${sort_order ? `&sort_type=${sort_order}` : ''}${search ? `&search=${search}` : ''}${name ? `&name=${name}` : ''}${entityparam ? `&entity=${entityparam}` : ''}${statusparam ? `&status=${statusparam}` : ''}${assignedparam ? `&assigned_to=${assignedparam}` : ''}${datetypeparam && fromparam && toparam? `&dateType=${datetypeparam}` : ''}${datetypeparam && fromparam && toparam ? `&startDate=${fromparam}` : ''}${datetypeparam && fromparam && toparam ? `&endDate=${toparam}` : ''}&download=true`;

        getResponse.GetProjectReportList(URL, accesstoken, (response) => {
            if(response.status == 200) {
                console.log("reportdownloadresponse", response)
                setProjectReportdownload(response.data.data);
            } else if(response.status == 401) {
                navigate("/login")
            }
        });
    }, [page, searchstate, sortstate, projectstate, entitystate, statustate, assignstate, datetypestate, fromstate, tostate, limit]);

    const handleEntryDropdown = (value) => {
        setLimit(value);
        HandleChange(1);
    }

    return (
        <div className='project-report-container'>
            <Header />
            <div className='row project-report-section'>
                <Sidebar />
                <div className='col-10 projectreport-right'>
                    <Breadcrumbs/>
                    <div className='sub-header'>
                        <Entries handleEntryDropdown={handleEntryDropdown} page="Projects Reports"/>
                        <SearchSection values={searchValues} handleFilter={Filter} 
                            callSearchApi={(query) => callSearchApi(query)} headers={headers} filename={filename}
                            pageType="ProjectsReports" setDownloadtype="" downloadtype="" downloadarray={projectReportdownload}
                        />     
                        {filterdetails &&
                            <>
                                <div className='filter-details' ref={filterwrapperRef}>
                                    <div className='first-row'>
                                        <div className='project-details'>
                                            <div className='project-heading heading'>Project Name</div>
                                            <input type="text" value={projectname} onChange={(e) => ProjectName(e)}></input>
                                        </div>
                                        <div className='entity-details'>
                                            <div className='label-input-dropdown'>
                                                <div className='date-type-heading heading'>Property</div>
                                                <Dropdown label={entityLabel} selectedItem={(name, id) => EntitySelect(name, id)}
                                                handleLabel={(value) => setEntityLabel(value)} list={entityList} enable={true} searchbar={true}/>
                                            </div>
                                        </div>
                                        <div className='project-status-details'>
                                            <div className='label-input-dropdown'>
                                                <div className='project-status-heading heading'>Project Status</div>
                                                <Dropdown label={statusLabel} selectedItem={(name, id) => StatusSelect(name, id)}
                                                handleLabel={(value) => setStatusLabel(value)} list={statusList} enable={true}/>
                                            </div>
                                        </div>
                                        {userRole == 1 &&
                                        <div className='assigned-to-details'>
                                            <div className='label-input-dropdown'>
                                                <div className='date-type-heading heading'>Assigned To</div>
                                                <Dropdown label={userLabel} selectedItem={(name, id) => AssignSeclect(name, id)}
                                                handleLabel={(value) => setUserLabel(value)} list={userList} enable={true}/>
                                            </div>
                                        </div>}
                                    </div>
                                    <div className='second-row'>
                                        <div className='date-type-details'>
                                            <div className='label-input-dropdown'>
                                                <div className='date-type-heading heading'>Date Type</div>
                                                <Dropdown label={datetypelabel} selectedItem={(name, id) => DateTypeSelect(name, id)}
                                                handleLabel={(value) => setDateTypelabel(value)} list={datetypelist} enable={true}/>
                                            </div>
                                        </div>
                                        <div className={`from-to ${disablefromto ? 'pointernone' : 'pointerall'}`}>
                                            <div className='from-date-details'>
                                                <div className='label-input label-input-due'>
                                                    <div className='from-date-heading heading'>From</div>
                                                    <Calender minDate={false} maxDate={new Date()} startdate={startfromdate} 
                                                        HandleDate={(date) => FromDate(date)} 
                                                        HandleLabel={(date) => setFromLabel(convertToDateString(date, "picker"))} label={fromlabel}
                                                        disablefromto={disablefromto} disableto={false} 
                                                    />
                                                </div>
                                            </div>
                                            <div className={`to-date-details ${disableto ? 'pointernone' : 'pointerall'}`}>
                                                <div className='label-input'>
                                                    <div className='to-date-heading heading'>To</div>
                                                    <Calender minDate={mindate} maxDate={new Date()} startdate={starttodate} 
                                                        HandleDate={(date) => ToDate(date)} HandleLabel={(date) => setToLabel(convertToDateString(date, "picker"))} 
                                                        label={tolabel} disablefromto={disablefromto} disableto={disableto}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='filter-details-arrow'></div>
                            </>
                        }   
                    </div>
                    {isLoading ?
                        (<Spinner/>) :
                        (<>
                            <div id="print" className='project-report-table'>
                                <table>
                                    <thead>
                                        <tr className='heading-row'>
                                            <th className='heading-data first-data' style={{minWidth: "200px", textAlign: "left"}}>
                                                <div className='heading-arrows'>
                                                    <div>Project Name</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'project' && sort_order === 'asc') && 
                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='project' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        { 
                                                            !(sort === 'project' && sort_order === 'desc') &&  
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='project' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                    </div>
                                                </div>
                                            </th>
                                            <th className='heading-data' style={{minWidth: "150px", textAlign: "left"}}>
                                                <div className='heading-arrows'>
                                                    <div>Status</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'status' && sort_order === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='status' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sort === 'status' && sort_order === 'desc') && 
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='status' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                    </div>
                                                </div>
                                            </th>
                                            <th className='heading-data' style={{minWidth: "150px", textAlign: "left"}}>
                                                <div className='heading-arrows'>
                                                    <div>Last Updated</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'last_updated' && sort_order === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='last_updated' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sort === 'last_updated' && sort_order === 'desc') && 
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='last_updated' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                    </div>
                                                </div>
                                            </th>
                                            <th className='heading-data' style={{minWidth: "150px", textAlign: "left"}}>
                                                <div className='heading-arrows'>
                                                    <div>Billable Hours</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'billhrs' && sort_order === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='billhrs' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        { 
                                                            !(sort === 'billhrs' && sort_order === 'desc') && 
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='billhrs' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                    </div>
                                                </div>
                                            </th>
                                            <th className='heading-data' style={{minWidth: "150px", textAlign: "left"}}>
                                                <div className='heading-arrows'>
                                                    <div>Actual Hours</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'acthrs' && sort_order === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow"  data-sort-by='acthrs' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sort === 'acthrs' && sort_order === 'desc') &&
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='acthrs' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                    </div>
                                                </div>
                                            </th>
                                            <th className='heading-data last-data' style={{minWidth: "50px", textAlign: "left"}}>
                                                <div className='heading-arrows'>
                                                    <div>Project Due</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'duedate' && sort_order === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='duedate' data-sort-type='asc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sort === 'duedate' && sort_order === 'desc') && 
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='duedate' data-sort-type='desc' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                    </div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {
                                        projectReportlists.length === 0 ? <p className="no-result">No results found</p> :
                                        <tbody>
                                            {projectReportlists && projectReportlists.length > 0 && projectReportlists.map((item, index) => {
                                                return (
                                                    <tr className='details-list-row' key={index} onClick={() => ToProjectDetails(item.idprojects)}>
                                                        <td className='details-list-data first-data' style={{minWidth: "200px"}}>{item.name && item.name}</td>
                                                        <td className='details-list-data' style={{minWidth: "150px"}}>{item.status === 0 ? 'Incomplete' : 'Completed'}</td>
                                                        <td className='details-list-data' style={{minWidth: "150px"}}>{item.lastUpdated && convertUTCToPST(item.lastUpdated + 'Z', "updates")}</td>
                                                        <td className='details-list-data' style={{minWidth: "150px"}}>{item.billableHrs ? item.billableHrs : '——'}</td>
                                                        <td className='details-list-data' style={{minWidth: "150px"}}>{item.actualHrs ? item.actualHrs : '——'}</td>
                                                        <td className='details-list-data last-data' style={{minWidth: "50px"}}>{item.dueDate && convertToDateString(new Date(item.dueDate), "picker")}</td>                            
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    }
                                </table>
                            </div>
                            <div className='pagination'>
                                <Pagination page={page} setPage={setPage} totalpage={totalpage} HandleChange={HandleChange}/>
                            </div>
                        </>)}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ProjectReports;